export const muiSnackBarContentTheme = {
  styleOverrides: {
    root: () => {
      return {
        padding: "0px 16px",
        minHeight: "56px",
        flexWrap: "nowrap",
        boxShadow: "0 8px 16px rgba(16, 16, 18, 0.16)",
        borderRadius: "12px",
        alignItems: "start",
        "& .MuiSnackbarContent-message": {
          padding: "0px",
        },
        "& .MuiSnackbarContent-action": {
          padding: "0px",
        },
        "& .MuiIconButton-root": {
          "&:hover": {
            backgroundColor: "rgba(0,0,0,0)",
          },
        },
        "& .MuiGrid-root": {
          flexWrap: "nowrap",
        },
      };
    },
  },
};
